"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var material_1 = require("@mui/material");
var Dialog_1 = __importDefault(require("./Dialog"));
function ReturnToImportFormDialog(_ref) {
  var model = _ref.model,
    handleClose = _ref.handleClose;
  return react_1.default.createElement(Dialog_1.default, {
    maxWidth: "xl",
    open: true,
    onClose: handleClose,
    title: "Reference sequence"
  }, react_1.default.createElement(material_1.DialogContent, null, react_1.default.createElement(material_1.Typography, null, "Are you sure you want to return to the import form? This will lose your current view")), react_1.default.createElement(material_1.DialogActions, null, react_1.default.createElement(material_1.Button, {
    onClick: function onClick() {
      model.clearView();
      handleClose();
    },
    variant: "contained",
    color: "primary",
    autoFocus: true
  }, "OK"), react_1.default.createElement(material_1.Button, {
    onClick: function onClick() {
      return handleClose();
    },
    color: "secondary",
    variant: "contained"
  }, "Cancel")));
}
exports.default = (0, mobx_react_1.observer)(ReturnToImportFormDialog);